<template>
  <div class="uk-margin uk-width-large uk-margin-auto uk-card uk-card-default uk-card-body uk-box-shadow-large">
    <form @submit.prevent="validateBeforeSubmit">
      <section>
        <h3 class="subtitle">{{$t('register.title')}}
          <router-link to="/">{{$t('name')}}</router-link>
        </h3>
        <b-field :label="$t('register.email')"
          :type="{'is-danger': errors.has('email')}"
          :message="[
            errors.firstByRule('email', 'required') ? $t('validate.email_required') : null
          ]">
          <b-input
            name="email"
            :placeholder="$t('register.email_placeholder')"
            type="email"
            icon="at"
            v-validate="'required'"
            v-model="model.email">
          </b-input>
        </b-field>
        <b-field :label="$t('register.password')"
          :type="{'is-danger': errors.has('password')}"
          :message="[
            errors.firstByRule('password', 'required') ? $t('validate.required') : null,
            errors.firstByRule('password', 'min') ? $t('validate.min')+'6' : null,
            errors.firstByRule('password', 'max') ? $t('validate.max')+'32' : null
          ]">
          <b-input
            :placeholder="$t('register.password_placeholder')"
            type="password"
            icon="key"
            name="password"
            password-reveal
            v-model="model.password"
            v-validate="'required|min:6|max:32'">
          </b-input>
        </b-field>
        <b-field :label="$t('register.confirm_password')"
          :type="{ 'is-danger': errors.has('confirm-password') }"
          :message="[
            errors.firstByRule('confirm-password', 'required') ? $t('validate.required') : null,
            errors.firstByRule('confirm-password', 'is') ? $t('validate.password_not_same') : null,
          ]">
          <b-input
            :placeholder="$t('register.confirm_password_placeholder')"
            type="password"
            icon="key"
            name="confirm-password"
            password-reveal
            v-model="confirmPassword"
            v-validate="{ required: true, is: model.password }">
          </b-input>
        </b-field>
        <b-field :label="$t('register.primary_name')"
          :type="{'is-danger': errors.has('primary_name')}"
          :message="[
            errors.firstByRule('primary_name', 'required') ? $t('validate.primary_name_required') : null,
          ]">
            <b-input
              name="primary_name"
              :placeholder="$t('register.primary_name_placeholder')"
              icon="address-card"
              v-validate="'required'"
              v-model="model.primary_name">
            </b-input>
        </b-field>
        <b-field :label="$t('register.secondary_name')"
          :type="{'is-danger': errors.has('secondary_name')}"
          :message="[
            errors.firstByRule('secondary_name', 'required') ? $t('validate.secondary_name_required') : null,
          ]">
            <b-input
              name="secondary_name"
              :placeholder="$t('register.secondary_name_placeholder')"
              icon="address-card"
              v-validate="'required'"
              v-model="model.secondary_name">
            </b-input>
        </b-field>
        <b-field :label="$t('register.phone')"
          :type="{'is-danger': errors.has('phone')}"
          :message="[
            errors.firstByRule('phone', 'required') ? $t('validate.phone_required') : null,
          ]">
            <b-input
              name="phone"
              :placeholder="$t('register.phone_placeholder')"
              icon="phone"
              icon-pack="fa"
              v-validate="'required'"
              v-model="model.phone">
            </b-input>
        </b-field>
        <b-field :label="$t('register.company_name')">
          <b-input
            name="company_name"
            :placeholder="$t('register.company_name_placeholder')"
            icon="building"
            icon-pack="fa"
            v-model="model.company_name">
          </b-input>
        </b-field>
        <vue-recaptcha v-if="need_capcha"
          ref="recaptcha"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          size="invisible"
          :sitekey="key_capcha">
        </vue-recaptcha>
        <b-field grouped>
          <b-field>
            <button class="button is-primary">{{$t('register.submit')}}</button>
          </b-field>
          <b-field position="is-right">
            <router-link to="/login">
              <button class="button is-primary">{{$t('register.another')}}</button>
            </router-link>
          </b-field>
        </b-field>
      </section>
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate, {
    events: '',
})

// import { doRegisterClient, needCaptcha, getCaptchaKey } from "@/api"
import { doRegisterClient } from "@/api"
import { EventBus } from '@/utils'

// import VueRecaptcha from 'vue-recaptcha';

export default {
  name: 'RegisterСlient',
  components: {
    VueRecaptcha: () => import('vue-recaptcha'),
  },
  props: {
    //
  },
  data: function () {
    return {
      confirmPassword: '',
      model: {
        email: null,
        password: null
      },
      // need_capcha: false,
      // key_capcha: null,
      next: '/register'
    }
  },
  created: function() {
    //
  },
  computed: {
    need_capcha () {
      return this.$store.getters.isNeedCaptcha
    },
    key_capcha () {
      return this.$store.getters.getCaptchaKey
    }
  },
  beforeMount: function(){
    //
  },
  mounted () {
    let $this = this

    // getCaptchaKey().then(response => {
    //   if (response.data) {
    //     $this.key_capcha = response.data.data
    //   }
    // })

    // needCaptcha().then(response => {
    //  if (response.data) {
    //    if (response.data.data == true){
    //      $this.need_capcha = true
    //    }
    //  }
    // })

    EventBus.$on('errorRegistering', (msg) => {
      this.$toast.open({
        message: `${$this.$i18n.t('notify.server_error')}: ${msg}`,
        type: 'is-danger',
        position: 'is-bottom'
      })
      $this.next = "/login"
    })
    EventBus.$on('failedRegistering', (msg) => {
      this.$toast.open({
        message: `${this.$i18n.t('notify.error_registered')}: ${msg}`,
        type: 'is-danger',
        position: 'is-bottom'
      })
      $this.model.password = ''
      $this.confirmPassword = ''
      $this.next = "/register"
    })
    EventBus.$on('successRegistering', () => {
       $this.$toast.open({
        message: $this.$i18n.t('notify.success_registered'),
        type: 'is-success',
        position: 'is-bottom'
      })
      $this.next = "/login"
    })
  },
  beforeDestroy () {
    EventBus.$off('errorRegistering')
    EventBus.$off('failedRegistering')
    EventBus.$off('successRegistering')
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this

      if ($this.need_capcha){

        $this.$validator.validateAll().then((result) => {
          if (result) {
            $this.$refs.recaptcha.execute();
            return;
          }
          $this.$toast.open({
            message: $this.$i18n.t('notify.form_error'),
            type: 'is-danger',
            position: 'is-bottom'
          })
        });

      }
      else{
        this.$validator.validateAll().then((result) => {
          if (result) {
            $this.sendPayload($this.model)
          }
        })
      }
    },
    onCaptchaVerified: function (recaptchaToken) {
      const $this = this;
      $this.$refs.recaptcha.reset();

      let payload = $this.model
      payload["g-recaptcha-response"] = recaptchaToken

      $this.sendPayload(payload)

    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
    sendPayload: function (payload) {
      let $this = this;

      $this.$store.dispatch('registerClient', payload).then(() => {
        $this.$router.push($this.next)
      })
    }
  }
}
</script>

<style scoped>
</style>
<style>
</style>